import {
	type TokenResponse,
	type Claim,
	type ClaimKey,
	claimKeys
} from "./AuthenticationTypes"
import { useLocalStorageState } from "./useLocalStorageState"

const credentialStorageKey = "authentication"
const claimsStorageKey = "claims"

export const useCredentialFromStorage = () =>
	useLocalStorageState<TokenResponse>(credentialStorageKey)
export const useClaims = () => useLocalStorageState<Claim[]>(claimsStorageKey)

export const getCredentialFromStorage = () => {
	const value = localStorage.getItem(credentialStorageKey)
	const json = value ? (JSON.parse(value) as TokenResponse) : undefined
	return json
}

export const getClaimsFromStorage = () => {
	const value = localStorage.getItem(claimsStorageKey)
	const claimsArray = value ? (JSON.parse(value) as Claim[]) : undefined

	if (!claimsArray) {
		return {} as Record<ClaimKey, string>
	}

	const claimsMap = claimsArray.reduce(
		(prev, curr) => {
			prev[curr.type] = curr.value
			return prev
		},
		{} as Record<ClaimKey, string>
	)

	return claimsMap
}

export const getUserEmailFromCredentialInStorage = () => {
	const claims = getClaimsFromStorage()
	return claims[claimKeys.userName]
}
